import React, { Component } from "react";
import { connect } from "react-redux";
import actions from "../../redux/action";
import PurchaseRender from "./children/PurchaseRender";
import purchaseList from "../../constants/purchase";
import { requsetGetPurchase, requsetGetSubscription } from "../../api/apis";
import { GAPurchasePageDisplay } from "../../ga/purchase";
import "../../assets/purchase.scss";
import Utils from "../../../../utils/utils";

class Purchase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currPackage: null, //选中的套餐：month | year
      packageMap: purchaseList,
    };
    this.timer = null;
  }

  componentDidMount() {
    console.log("进来");
    this.handleListenerSubscription();
    GAPurchasePageDisplay();
  }

  componentWillUnmount() {
    //清除定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  //判断当前是否需要轮询订阅信息，如果需要就轮询
  handleListenerSubscription = () => {
    const urlParams = new URLSearchParams(this.props.urlSearch);
    const redirect = urlParams.get("redirect");
    const to = urlParams.get("to");
    if (redirect && to === "purchase") {
      console.log("需要轮训");
      this.timer = setInterval(() => {
        requsetGetSubscription()
          .then(res => {
            console.log(res);
            if (res.code === 200) {
              if (
                res.data.subscription &&
                res.data.subscription.status === "Active" &&
                (!this.props.subscription || (this.props.subscription && this.props.subscription.status === "Expired"))
              ) {
                console.log("监听到了用户已经购买");
                window.location.replace(redirect);
              }
              this.props.onSubscriptionChange(res.data.subscription);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }, 12000);
    }
  };

  /**
   *请求跳转购物车地址
   * @param {string} plan  month | year
   * @param {string} site  en | de | es | fr | jp | br | ru | ar | it | tr | nl | id | in | kr
   */
  handleGetPurchaseURL = plan => {
    const site = Utils.getLanguage() || "en";
    this.setState({
      currPackage: plan,
    });
    const formData = new FormData();
    formData.append("plan", plan);
    formData.append("site", site);
    requsetGetPurchase({
      body: formData,
    })
      .then(res => {
        console.log(res);
        if (res.code === 200) {
          //购物车地址
          let cartUrl = res.data.cart_url;
          window.open(cartUrl, "_blank");
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          currPackage: null,
        });
      });
  };

  render() {
    return (
      <div className="purchase-page overflow-hidden">
        <PurchaseRender packageMap={this.state.packageMap} currPackage={this.state.currPackage} handleGetPurchaseURL={this.handleGetPurchaseURL} />
      </div>
    );
  }
}

const mapStateToPropos = state => ({
  profileObj: state.account.profileObj,
  subscription: state.account.subscription,
  authorization: state.account.authorization,
});
const mapDispatchToProps = dispatch => ({
  onProfileObjChange: profileObj => dispatch(actions.onProfileObjChange(profileObj)),
  onAuthorizationChange: authorization => dispatch(actions.onAuthorizationChange(authorization)),
  onSubscriptionChange: subscription => dispatch(actions.onSubscriptionChange(subscription)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(Purchase);
